import React, { useState, useEffect } from "react";
import { useQuery } from "react-query";
import authApi from "../../../service/IdApi";
import PageLoadError from "../../../components/PageLoadError";
import PageHeading from "../../../components/PageHeading";
import { Button } from 'primereact/button';
import { MultiSelect } from "primereact/multiselect";
import { Chart } from "primereact/chart";
import { Dropdown } from 'primereact/dropdown';

const Events = () => {
    const [events, setEvents] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [showDetailsDialog, setShowDetailsDialog] = useState(false);
    const [selectedEvents, setSelectedEvents] = useState([]);
    const [chartData, setChartData] = useState(null);
    const [chartOptions, setChartOptions] = useState({});
    const [range, setRange] = useState("week");

    const rangeOptions = [
        { value: 'week', label: 'Last Week' },
        { value: 'month', label: 'Last Month' }
    ];

    const { isLoading, isFetching, isError, refetch } = useQuery(["Events"], async () => {
        if (events.length === 0) {
            const result = await authApi.get("admin/popular-events");
            var _events = [];
            for (var i = 0; i < result.data.events.myArrayList.length; i++) {
                var _event = {};
                _event.key = result.data.events.myArrayList[i];
                _event.value = result.data.events.myArrayList[i];
                _events.push(_event);
            }
            setEvents(_events);
        }
        if (selectedEvents.length > 0) {
            var body = {};
            body.fromDate = range === "week"
                ? new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
                : new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
            body.toDate = new Date().toISOString().split('T')[0];
            body.eventNames = selectedEvents;
            body.unit = "day";
            const result = await authApi.post("admin/events", body);
            const apiData = result.data.data.map.data.map;
            const labels = apiData.series.myArrayList;
            const friendlyLabels = apiData.series.myArrayList.map(date => date.slice(5));
            const color1 = { backgroundColor: "#0d6efd", borderColor: "#0d6efd" };
            const color2 = { backgroundColor: "#d63384", borderColor: "#d63384" };
            const color3 = { backgroundColor: "#F7C223", borderColor: "#F7C223" };
            const color4 = { backgroundColor: "#1B9A59", borderColor: "#1B9A59" };
            const color5 = { backgroundColor: "#DE3E35", borderColor: "#DE3E35" };
            const color6 = { backgroundColor: "#9c1c93", borderColor: "#9c1c93" };
            const colors = [color1, color2, color3, color4, color5, color6];
            const datasets = Object.entries(apiData.values.map).map(([key, value], index) => {
                const color = colors[index];
                return {
                    label: key,
                    backgroundColor: color.backgroundColor,
                    borderColor: color.borderColor,
                    data: labels.map(date => value.map[date] || 0)
                };
            });

            const newChartData = {
                labels: friendlyLabels,
                datasets: datasets
            };
            setChartData(newChartData);
        }
        setLoaded(true);
    });

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
        const options = {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
                legend: {
                    labels: {
                        fontColor: textColor
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary,
                        font: {
                            weight: 500
                        }
                    },
                    grid: {
                        display: false,
                        drawBorder: false
                    }
                },
                y: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    }
                }
            }
        };
        setChartOptions(options);
    }, []);

    const pageHeader = (
        <PageHeading pageTitle="Admin - Events">
            <div className="block">
            </div>
        </PageHeading>
    );

    if (isError) {
        return (
            <div>
                {pageHeader}
                <PageLoadError />
            </div>
        );
    }

    const handleSearch = () => {
        refetch();
    };

    const selectedEventsChanged = (e) => {
        setSelectedEvents(e.value);
    }



    return (
        <div>
            {pageHeader}
            <div className="layout-content">
                <div className="card pt-3 sm:pt-0">
                    <div className="flex pt-3 w-full">
                        <div className="flex flex-row text-lg align-items-center">
                            Select one or more events to search in Mixpanel.
                        </div>
                        <div className="flex flex-row flex-grow-1 justify-content-end">
                        </div>
                    </div>
                    <div className="flex py-3 w-full">
                        <div className="flex flex-row">
                            <div>
                                <MultiSelect value={selectedEvents} onChange={selectedEventsChanged} options={events} optionLabel="value"
                                    placeholder="Select events..." maxSelectedLabels={3} className="w-full" selectedItemsLabel={selectedEvents.length + ' Events Selected'} filter={true} />
                            </div>
                            <div>
                                <Dropdown value={range} onChange={(e) => setRange(e.value)} options={rangeOptions} optionLabel="label" optionValue="value" placeholder="Select range" />
                            </div>
                            <div>
                                <Button
                                    icon="pi pi-search"
                                    className="p-button-primary"
                                    onClick={handleSearch}
                                    tooltip="Search"
                                />
                            </div>
                        </div>
                        <div className="flex flex-row flex-grow-1 justify-content-end">
                        </div>
                    </div>
                    {chartData && (
                        <Chart type="bar" data={chartData} options={chartOptions} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Events;